import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_8 = { class: "fw-bold text-muted text-hover-primary fs-7" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_10 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_11 = { class: "menu-link px-5" }
const _hoisted_12 = { class: "menu-title position-relative" }
const _hoisted_13 = { class: "fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "symbol symbol-20px me-4" }
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_20 = {
  class: "menu-item px-5 my-1",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_21 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            alt: "Logo",
            src: _ctx.avatarUrl
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.username), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.email), 1)
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", _hoisted_12, [
          _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.userMenu.language")) + " ", 1),
          _createElementVNode("span", _hoisted_13, [
            _createTextVNode(_toDisplayString(_ctx.currentLanguageLocale.name) + " ", 1),
            _createElementVNode("img", {
              class: "w-15px h-15px rounded-1 ms-2",
              src: _ctx.currentLanguageLocale.flag,
              alt: _ctx.currentLanguageLocale.name
            }, null, 8, _hoisted_14)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (c) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "menu-item px-3",
            key: c.locale
          }, [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.setLang(c.locale)),
              class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage(c.locale) }])
            }, [
              _createElementVNode("span", _hoisted_17, [
                _createElementVNode("img", {
                  class: "rounded-1",
                  src: c.flag,
                  alt: c.name
                }, null, 8, _hoisted_18)
              ]),
              _createTextVNode(" " + _toDisplayString(c.name), 1)
            ], 10, _hoisted_16)
          ]))
        }), 128))
      ])
    ]),
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_router_link, {
        to: "/account/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.userMenu.account")), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, _toDisplayString(_ctx.I18nUtils.translate("sea.userMenu.signOut")), 1)
    ])
  ]))
}